module.exports = __webpack_public_path__ + "assets/img/ulu pandan 109m.ddaeeb78.jpg";